import { useEffect, useState } from "react";
import { logoSvgBase } from "./LandingHeader.config";
import { AvailableLanguage } from "../../../Interface/logoLang";

const useLogoSvg = (
  svgLogo?: keyof typeof logoSvgBase,
  lang?: AvailableLanguage
) => {
  const [logoSvgSrc, setLogoSvgSrc] = useState<string>();

  useEffect(() => {
    if (svgLogo) {
      if (typeof logoSvgBase[svgLogo] === "function") {
        logoSvgBase[svgLogo](lang).then(setLogoSvgSrc);
      } else {
        setLogoSvgSrc(logoSvgBase[svgLogo]);
      }
    }
  }, [svgLogo, lang]);

  return { logoSvgSrc };
};

export default useLogoSvg;
